'use client';

import { createContext } from 'react';

import type { AppConfig } from '@utazzo/shared';

/**
 * AppConfig is the single source of truth for branding, theme, locale,
 * feature flags, and limits in the frontend.
 *
 * Components NEVER hardcode any of these values. They read them from this
 * context via the `useAppConfig()` hook (or `useFeatureFlag(key)` for flags).
 */
export interface AppConfigContextValue {
  config: AppConfig;
  refresh: () => Promise<void>;
}

export const AppConfigContext = createContext<AppConfigContextValue | null>(null);
